import React from 'react';
import { Box } from '@mui/material';

interface GridContainerProps {
  children: React.ReactNode;
  columns?: number;
  minWidth?: string;
  sx?: any;
}

const GridContainer: React.FC<GridContainerProps> = ({ 
  children, 
  columns = 2, 
  minWidth = '300px',
  sx 
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}, 1fr))`,
        gap: '16px',
        padding: '16px 0',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default GridContainer;

